// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const debounce = <T extends any[]>(
  fn: (...args: T) => void,
  timeout: number,
) => {
  let handle = 0;
  let lastArgs: T | undefined;

  const ret = (...args: T) => {
    lastArgs = args;
    clearTimeout(handle);
    handle = window.setTimeout(() => {
      lastArgs = undefined;
      fn(...args);
    }, timeout);
  };

  ret.flush = () => {
    clearTimeout(handle);
    if (lastArgs) {
      const _lastArgs = lastArgs;
      lastArgs = undefined;
      fn(..._lastArgs);
    }
  };

  ret.cancel = () => {
    lastArgs = undefined;
    clearTimeout(handle);
  };

  return ret;
};
